module.exports = __webpack_public_path__ + "img/img11.d837a93c.svg";